// testimonial one data
export const testimonial_data = [
  {
    id: 1,
    img: "/assets/img/testimonial/Dana Hattar Avatar.jpg",
    title: "Why did you choose Al-Hussein Technical University?",
    titleAr: "لماذا اخترت جامعة الحسين التقنية؟",
    content:
      "“For its unique offering that allows students to seamlessly transition from an associate degree to a bachelor’s degree, supported by a specialized faculty with practical experience in engineering, industry, and business sectors.”",
    contentAr:
      "“لأنها تقدّم مساراً فريداً يتيح للطلبة الانتقال السلس من الدرجة التقنيّة إلى درجة البكالوريوس، مع دعم من كادر متخصص يجمع بين الخبرة العملية في الهندسة والصناعة وقطاع الأعمال.”",
    name: "Dana Hattar",
    nameAr: "دانا حتر",
    position: "Alumna",
    positionAr: "خرّيجة",
    alt: "Dana Hattar Avatar",
  },
  {
    id: 2,
    img: "/assets/img/testimonial/Anas Malas Avatar.jpg",
    title: "Why did you choose your field of study?",
    titleAr: "لماذا اخترت تخصصك؟",
    content:
      "“Ever since I was a child, I’ve been fascinated by the world of electronics. I used to take apart devices just to understand how they worked. My passion for this field grows stronger every day, especially after choosing Al Hussein Technical University, where the focus is on hands-on, project-based learning.”",
    contentAr:
      "“منذ طفولتي وأنا مهووس بالإلكترونيات. كنت أفكّك الأجهزة لأكتشف كيف تعمل. شغفي بهذا المجال يزداد يوماً بعد يوم، خاصة بعد انضمامي لجامعة الحسين التقنية التي تركز على التعلم العملي والمشاريع الواقعية.”",
    name: "Anas Malas",
    nameAr: "أنس ملص",
    position: "Alumni",
    positionAr: "خرّيج",
    alt: "Anas Malas Avatar",
  },
  {
    id: 3,
    img: "/assets/img/testimonial/Ali Ashqar Avatar.jpg",
    title: "What prepares you for life after university, and why?",
    titleAr: "ما الذي يهيّئك للحياة بعد التخرج؟ ولماذا؟",
    content:
      "“The evaluation approach at Al Hussein Technical University, which often emphasizes teamwork and self learning, is key to life after graduation. These two aspects are fundamental in the professional world. They have enhanced my ability to collaborate within a team and strengthened my drive for continuous, self-motivated learning.”",
    contentAr:
      "“أسلوب التقييم في جامعة الحسين التقنية، الذي يركز على العمل الجماعي والتعلّم الذاتي، هو أساس النجاح بعد التخرج. هذان العنصران ضروريان في بيئة العمل، وقد طوّرا لديّ القدرة على التعاون ضمن فريق، وعززَا من رغبتي في التعلّم المستمر والمستقل.”",
    name: "Ali Ashqar",
    nameAr: "علي أشقر",
    position: "Alumni",
    positionAr: "خرّيج",
    alt: "Ali Ashqar Avatar",
  },
  {
    id: 4,
    img: "/assets/img/testimonial/Elham Abu Shtieh Avatar.jpg",
    title: "Why did you choose Al-Hussein Technical University?",
    titleAr: "لماذا اخترت جامعة الحسين التقنية؟",
    content:
      "“I chose Al Hussein Technical University because it’s a place for the brave. I knew it required determination and a strong will to succeed. The university emphasizes hands-on learning and hard work to turn dreams into reality.”",
    contentAr:
      "“اخترت جامعة الحسين التقنية لأنها جامعة للمغامرين والطموحين. كنت أعلم أن النجاح فيها يتطلب إرادة قوية وتصميماً حقيقياً. ما يميزها هو التركيز على التعليم التطبيقي والعمل الجاد لتحقيق الأحلام وتحويلها إلى واقع.”",
    name: "Elham Abu Shtieh",
    nameAr: "إلهام أبو شتية",
    position: "Alumna",
    positionAr: "خرّيجة",
    alt: "Elham Abu Shtieh Avatar",
  },
];

export const testimonial_data_2 = [
  {
    id: 1,
    title: "CPD/HTU: A Pillar of Upskilling Excellence",
    titleAr: "مركز التطوير الوظيفي في HTU: ركيزة أساسية في برامج رفع الكفاءة",
    content:
      "“As a key partner in our upskilling ecosystem, CPD/HTU has played a pivotal role in the success of the pilot upskilling phase under MoDEE/YTJ program (funded by a World Bank loan) which was implemented by Digiskills. From beginning to end, CPD has demonstrated highest levels of professionalism and efficiency. Their experienced a highly qualified team managed the program in a way that assured delivery of all milestones (selection of candidates, training delivery, certification and employment) efficiently with excellence. We highly commend CPD for their exceptional performance and are keen to continue working closely with them”",
    contentAr: `بصفته شريكًا أساسيًا في منظومتنا الوطنية لرفع الكفاءة، لعب مركز التطوير الوظيفي في جامعة الحسين التقنية دورًا محوريًا في نجاح المرحلة التجريبية من برنامج وزارة الاقتصاد الرقمي والريادة/Youth, Technology and Jobs والممول من البنك الدولي، والذي نُفذ من قبل جمعية ديجي سكيلز.
منذ البداية وحتى نهاية التنفيذ، أظهر فريق المركز أعلى درجات المهنية والكفاءة. وقد أدار هذا الفريق الخبير والمؤهل البرنامج بكفاءة عالية ضمنت تحقيق جميع المخرجات من اختيار المتدربين، إلى تنفيذ التدريب، ومنح الشهادات، وصولًا إلى التوظيف.
نثمن الأداء المميز لمركز التطوير المهني، ونتطلع إلى استمرار التعاون الوثيق معهم.`,
    name: "Dr. Nabeel Alfayoumi",
    nameAr: "د. نبيل الفيومي",
    position: "Managing Director of Digiskills Association",
    positionAr: "المدير التنفيذي لجمعية ديجي سكيلز",
  },
  {
    id: 2,
    title: "HTU: Shaping Talent for SITA Amman",
    titleAr: "HTU: تصنع الكفاءات لـ SITA",
    content:
      "“Our partnership with HTU began in 2018, driving significant growth at SITA Amman. The first upskilling program, designed with HTU, was a great success, focusing on airport operations support. From program design to candidate selection, HTU’s collaboration was invaluable. Out of 20 trainees, 16 were recruited, excelling in handling customer support calls from 350 airports worldwide. Today, a quarter of our 150 staff come from HTU programs. We see HTU as a trusted partner, shaping talent for our industry, and we look forward to continuing this impactful collaboration for Jordan’s youth.”",
    contentAr: `بدأت شراكتنا مع جامعة الحسين التقنية في عام 2018، وأسهمت في تحقيق نمو ملحوظ في أعمال شركة SITA عمّان.
كان أول برنامج لرفع الكفاءة بالشراكة مع HTU نقطة تحوّل، حيث ركز على دعم عمليات المطارات. ومن تصميم البرنامج إلى اختيار المرشحين، كانت HTU شريكًا لا غنى عنه.
من أصل 20 متدربًا، تم توظيف 16، وبرزوا في تقديم الدعم الفني لأكثر من 350 مطارًا حول العالم.
واليوم، يشكل خريجو HTU ما يقارب ربع موظفي SITA في عمّان والبالغ عددهم 150 موظفًا.
نحن نرى في HTU شريكًا موثوقًا في إعداد الكفاءات لسوق العمل، ونتطلع إلى مواصلة هذا التعاون المؤثر لصالح شباب وشابات الأردن.`,
    name: "Khaled Salman",
    nameAr: "خالد سلمان",
    position: "General Manager, SITA at Borders",
    positionAr: "المدير العام، SITA at Borders",
  },
];
